<template>
  <div class="container-fluid p-4">
    <bnp-grid :hasRowNum="true" :key="keys" :propsColumn="columns" :propsRows="rows" :action="false"></bnp-grid>
  </div>
</template>
<script>
import BnpGrid from '@/components/BnpGrid/BnpGrid.vue'
export default {
  components: { BnpGrid },
  props: ['tblCustomerId'],
  data() {
    return {
      rows: [],
      columns: [
        {
          id: 101796,
          name: 'fieldCaption',
          visibility: true,
          width: 0,
          indexCol: 0,
          label: 'نام فیلد',
          sort: false,
        },
        {
          id: 101796,
          name: 'oldValue',
          visibility: true,
          width: 0,
          indexCol: 0,
          label: 'مقدار قدیم',
          sort: false,
        },
        {
          id: 101796,
          name: 'newValue',
          visibility: true,
          width: 0,
          indexCol: 0,
          label: 'مقدار جدید',
          sort: false,
        },
        {
          id: 101796,
          name: 'userNameFamily',
          visibility: true,
          width: 0,
          indexCol: 0,
          label: 'ایجاد کننده تغییر',
          sort: false,
        },
        {
          id: 101796,
          name: 'zamanLog',
          visibility: true,
          width: 0,
          indexCol: 0,
          label: 'زمان تغییر',
          sort: false,
        },
      ],
      keys: 0,
    }
  },
  created() {
    this.GetLogInfo()
  },
  methods: {
    GetLogInfo() {
      this.$PostData({ Method: 'Post', ArryfildValue: { FKID: this.tblCustomerId }, Action: 'UserLogInformationRiz/GetLogRizByFK' }).then((result) => {
        console.warn(result)
        this.rows = result
        this.keys++
      })
    },
  },
}
</script>
